<div class="project-list-page">
  <div class="project-list-topbar">
    <!-- <h1 class="project-list-title">{{this.translate.data['YOURPROJECTS'] | translate}}</h1> -->
    <h1 class="project-list-title">Projekte</h1>
    <div class="project-list-actions">
      <div class="project-search">
        <i class="material-icons project-search-icon">search</i>
        <input type="text" name="projectSearch" class="project-search-input" [(ngModel)]="searchTerm" placeholder="Projekt suchen">
        @if (searchTerm) {
          <button type="button" class="project-search-clear" aria-label="Suche leeren" (click)="searchTerm = ''">
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>

      <button type="button" class="project-sort-button" [matMenuTriggerFor]="sortMenu"
              (menuOpened)="sortMenuOpen = true" (menuClosed)="sortMenuOpen = false">
        <span class="project-sort-button-label">
          <mat-icon>swap_vert</mat-icon>
          <span>{{ currentSortLabel }}</span>
        </span>
        <mat-icon>{{ sortMenuOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
      <mat-menu #sortMenu="matMenu">
        @for (opt of sortOptions; track opt.value) {
          <button mat-menu-item (click)="setSort(opt.value)">
            <span [class.project-sort-active]="selectedSort === opt.value">{{ opt.label }}</span>
            @if (selectedSort === opt.value) {
              <mat-icon class="project-sort-check">check</mat-icon>
            }
          </button>
        }
      </mat-menu>
    </div>
  </div>

  <div class="project-list-body">
    @if (isLoadingResults || isRateLimitReached) {
      <div class="project-list-loading">
        @if (isLoadingResults) {
          <mat-spinner></mat-spinner>
        }
        @if (isRateLimitReached) {
          <div class="project-list-rate-limit">
            Squirrel's API rate limit has been reached. It will be reset in one minute.
          </div>
        }
      </div>
    }

    @if (!isLoadingResults) {
      @if (projects.length > 0 && filteredProjects.length === 0) {
        <!-- <div class="hinweis hinweis__fehler" role="alert"> -->
        <div class="project-list-empty" role="alert">
          <mat-icon>error_outline</mat-icon>
          <span>Kein Projekt passt zu Ihrer Suche.</span>
          <button type="button" class="project-list-empty-reset" (click)="searchTerm = ''">
            Suche zurücksetzen
          </button>
        </div>
      }
      @else {
        <!-- Kacheln statt Zeilen (wie in squirrel-login): das Motiv traegt die
             Wiedererkennung, darunter Name und Anlagedatum -->
        <ul class="kacheln">
          @for (project of filteredProjects; track project.id) {
            <li>
              <!-- Nur Kacheln mit Beschreibung lassen sich wenden -->
              <button type="button" class="kachel"
                      [class.kachel--wendet]="!!project.description"
                      (click)="onRowClicked(project)">
                <!-- Vorn das Motiv, hinten der Zweck: die Bildflaeche wendet sich
                     im Mauskontakt, Name und Datum bleiben stehen -->
                <span class="kachel__bild">
                  <span class="kachel__wender">
                    <span class="kachel__seite kachel__seite--vorn"
                          [class.kachel__seite--ersatz]="!project.image">
                      @if (project.image) {
                        <img class="kachel__motiv" [src]="'data:image/jpeg;base64,' + project.image" alt="" loading="lazy" />
                      } @else {
                        <span class="kachel__kuerzel" aria-hidden="true">{{ getInitials(project.display_Name) }}</span>
                      }
                    </span>

                    @if (project.description) {
                      <span class="kachel__seite kachel__seite--hinten">
                        <span class="kachel__zweck">{{ project.description }}</span>
                      </span>
                    }
                  </span>
                </span>

                <span class="kachel__text">
                  <span class="kachel__name">{{ project.display_Name }}</span>
                </span>

                <span class="kachel__fuss">
                  <span class="kachel__datum">Erstellt am {{ project.createdWhen | date:'dd.MM.yyyy' }}</span>
                  <mat-icon class="kachel__pfeil">chevron_right</mat-icon>
                </span>
              </button>
            </li>
          }
        </ul>
      }
    }
  </div>
</div>
